module.exports = __webpack_public_path__ + "fonts/AvenirLTW02-55Roman.2edebae056e4eaca4d08d984c81adfe9.woff2";